import React from "react";
import i18n from "i18next";
const accountTypes = {
  BNS: "Nacional BNS",
  LOCAL: "Nacional SINPE/ACH",
  INT: "Internacional",
};

const getItems = (userType, global) => {
  const defaultSignerName = i18n.t(
    "providers.manual.form.signersName.placeholder"
  );
  const defaultSignerId = i18n.t("providers.manual.form.signersId.placeholder");

  return {
    0: [
      {
        label: `${i18n.t("providers.manual.form.account_name")}`,
        name: "companyName",
      },
      {
        label: `${i18n.t("providers.manual.form.id.label")}`,
        name: "businessId",
      },
    ],
    1: [
      {
        label: `${i18n.t("providers.manual.form.main_address")}`,
        name: "address",
      },
      {
        label: `${i18n.t("providers.manual.form.phone.label")}`,
        name: "phoneProvider",
      },
    ],
    2: [
      {
        label: `${i18n.t("providers.manual.form.city.label")}`,
        name: "residenceCity",
      },
      {
        label: `${i18n.t("providers.manual.form.main_country")}`,
        name: "countryName",
      },
    ],
    3: [
      {
        label: `${i18n.t("providers.manual.form.contact.label")}`,
        name: "notificationNameProvider",
      },
      {
        label: `${i18n.t("providers.manual.form.email.label")}`,
        name: "notificationEmailProvider",
      },
    ],
    4: [
      {
        label: `${i18n.t("providers.manual.form.accountType")}`,
        name: "accountType",
      },
      {
        label: `${i18n.t("providers.manual.form.bicDestiny.label")}`,
        name: "bicDestinationBank",
      },
    ],
    5: [
      {
        label: `${i18n.t("providers.manual.form.accountNumber.label")}`,
        name: "accountNumber",
      },
      {
        label: `${i18n.t("providers.manual.form.bicIntermediate.label")}`,
        name: "bicIntermediaryBank",
      },
    ],
    6: [
      {
        label: `${i18n.t("providers.manual.form.bicAccount.label")}`,
        name: "accountIntermediaryBank",
      },
      {
        label: `${i18n.t("providers.manual.form.currency.label")}`,
        name: "accountCurrency",
      },
    ],
    7: [
      {
        label: `${i18n.t("providers.manual.form.state")}`,
        name: "status",
      },
      {
        label: `${i18n.t("providers.manual.form.provider_type")}`,
        name: "toBillDiscount",
      },
    ],
    8: [
      {
        label: `${i18n.t("providers.manual.form.action")}`,
        name: "action",
      },
      {
        label: `${i18n.t("providers.manual.form.made_by")}`,
        name: "createBy",
      },
    ],
    ...(userType === "BSC" && {
      9: [
        {
          label: i18n.t("providers.manual.form.signersName.label"),
          name: "signerName",
          placeholder: defaultSignerName,
        },
        {
          label: i18n.t("providers.manual.form.signersId.label"),
          name: "signerId",
          placeholder: defaultSignerId,
        },
      ],
      10: [
        {
          label: i18n.t("providers.manual.form.signersName.label"),
          name: "signerName2",
          placeholder: defaultSignerName,
        },
        {
          label: i18n.t("providers.manual.form.signersId.label"),
          name: "signerId2",
          placeholder: defaultSignerId,
        },
      ],
      11: [
        {
          label: i18n.t("providers.manual.form.signersName.label"),
          name: "signerName3",
          placeholder: defaultSignerName,
        },
        {
          label: i18n.t("providers.manual.form.signersId.label"),
          name: "signerId3",
          placeholder: defaultSignerId,
        },
      ],
    }),
    ...(global && {
      12: [
        {
          label: i18n.t("general.labels.globalApproval"),
          name: "globalApproval",
        },
      ],
    }),
  };
};

const defaultMsg = i18n.t("general.labels.na");

export const formatData = (data, banks) => {
  const existRecords = !!data.recordTmps?.[0]?.data;
  const recordsDetails = data.recordTmps[0];

  const recordsData = data.recordTmps?.[0]?.data
    ? {
        ...data.recordTmps[0].data,
        account: data.recordTmps[0].data.account
          ? JSON.parse(data.recordTmps[0].data.account)
          : undefined,
        legalSignerWrappers: data.recordTmps[0].data.legalSignerList
          ? JSON.parse(data.recordTmps[0].data.legalSignerList)
          : undefined,
      }
    : null;

  const getBicDestination = (account) => {
    if (!account) return "N/A";
    let bic = account.bicDestinationBank;

    if (account.accountType === "LOCAL" && data.country.code === "PA") {
      bic = banks.find(({ idBankShort }) => idBankShort === bic).bankName;
    }

    return bic || defaultMsg;
  };

  const institution = {
    companyName: data.companyName,
    businessId: data.businessId,
    address: data.provider.address,
    phoneProvider: data.provider.phoneProvider,
    residenceCity: data.provider.residenceCity,
    countryName: data.provider.country.name,
    notificationNameProvider: data.provider.notificationNameProvider,
    notificationEmailProvider: data.provider.notificationEmailProvider,
    accountType:
      accountTypes[data?.provider?.accounts[0]?.accountType] || "N/A",
    bicDestinationBank: getBicDestination(data.provider?.accounts?.[0]),
    accountNumber: data.provider?.accounts?.[0]?.accountNumber || "N/A",
    bicIntermediaryBank:
      data.provider.accounts.length > 0
        ? data.provider?.accounts?.[0]?.bicIntermediaryBank || defaultMsg
        : "N/A",
    accountIntermediaryBank:
      data.provider.accounts.length > 0
        ? data.provider?.accounts?.[0]?.accountIntermediaryBank || defaultMsg
        : "N/A",
    accountCurrency:
      data.provider.accounts.length > 0
        ? data.provider?.accounts?.[0]?.accountCurrency === "CRC"
          ? "Colones"
          : "Dólares"
        : "N/A",
    status: i18n.t(`general.states.${data.provider.status}`),
    toBillDiscount: data.provider.toBillDiscount
      ? i18n.t("providerType.discount")
      : i18n.t("providerType.directPayment"),
    action:
      data.recordTmps?.[0]?.data?.action === undefined &&
      i18n.t("general.states.CREATION"),
    createBy: data.updateBy,
    signerName: data.provider?.legalSignerWrappers?.[0]?.signerName,
    signerId: data.provider?.legalSignerWrappers?.[0]?.signerIdentification,
    signerName2: data.provider?.legalSignerWrappers?.[1]?.signerName,
    signerId2: data.provider?.legalSignerWrappers?.[1]?.signerIdentification,
    signerName3: data.provider?.legalSignerWrappers?.[2]?.signerName,
    signerId3: data.provider?.legalSignerWrappers?.[2]?.signerIdentification,
    globalApproval: data.provider.globalApproval
      ? i18n.t("general.labels.yes")
      : i18n.t("general.labels.no"),
  };

  const getValue = (name, value) => {
    return value === undefined ? institution[name] : value;
  };

  const getLegalSigner = (name, pos) => {
    const defaultProperty = name.includes("signerId")
      ? "signerIdentification"
      : "signerName";

    return recordsData.legalSignerWrappers
      ? recordsData.legalSignerWrappers?.[pos]?.[defaultProperty]
      : institution[name];
  };

  institution["recordTmps"] = !existRecords
    ? data.recordTmps
    : [
        {
          data: {
            companyName: getValue("companyName", recordsData.name),
            businessId: getValue("businessId", recordsData.businessId),
            address: getValue("address", recordsData.address),
            phoneProvider: getValue("phoneProvider", recordsData.phoneProvider),
            residenceCity: getValue("residenceCity", recordsData.residenceCity),
            countryName: getValue("countryName", recordsData.countryName),
            notificationNameProvider: getValue(
              "notificationNameProvider",
              recordsData.notificationNameProvider
            ),
            notificationEmailProvider: getValue(
              "notificationEmailProvider",
              recordsData.notificationEmailProvider
            ),
            accountType: getValue(
              "accountType",
              accountTypes[recordsData.account?.accountType]
            ),
            bicDestinationBank: getValue(
              "bicDestinationBank",
              recordsData.account?.bicDestinationBank === undefined
                ? undefined
                : getBicDestination(recordsData.account)
            ),
            accountNumber: getValue(
              "accountNumber",
              recordsData.account?.accountNumber
            ),
            bicIntermediaryBank: getValue(
              "bicIntermediaryBank",
              recordsData.account?.bicIntermediaryBank === undefined
                ? undefined
                : recordsData.account?.bicIntermediaryBank || defaultMsg
            ),
            accountIntermediaryBank: getValue(
              "accountIntermediaryBank",
              recordsData.account?.accountIntermediaryBank === undefined
                ? undefined
                : recordsData.account?.accountIntermediaryBank || defaultMsg
            ),
            accountCurrency: getValue(
              "accountCurrency",
              recordsData.account?.accountCurrency === undefined
                ? undefined
                : recordsData.account?.accountCurrency || defaultMsg
            ),
            status: getValue(
              "status",
              recordsData.status === undefined
                ? undefined
                : i18n.t(`general.states.${recordsData.status}`)
            ),
            toBillDiscount: getValue(
              "toBillDiscount",
              recordsData.toBillDiscount === undefined
                ? undefined
                : recordsData.toBillDiscount
                ? "Descuento"
                : "Pago Directo"
            ),
            action:
              recordsDetails.action === "UPDATE"
                ? "Actualización"
                : recordsDetails.action === "DELETE"
                ? "Eliminar"
                : "Creación",
            createBy: recordsDetails.updateBy,
            signerName: getLegalSigner("signerName", 0),
            signerId: getLegalSigner("signerId", 0),
            signerName2: getLegalSigner("signerName2", 1),
            signerId2: getLegalSigner("signerId2", 1),
            signerName3: getLegalSigner("signerName3", 2),
            signerId3: getLegalSigner("signerId3", 2),
            globalApproval: getValue(
              "globalApproval",
              recordsData.globalAcceptance !== undefined
                ? recordsData.globalAcceptance
                  ? "Si"
                  : "No"
                : undefined
            ),
          },
        },
      ];

  return institution;
};

export const renderItems = (userType, getValue, main = true) => {
  const data = getItems(userType, getValue("toBillDiscount") === "Descuento");
  return (
    <>
      {Object.keys(data).map((key) => (
        <div className="row" key={key}>
          {data[key].map(({ name, label, placeholder }) => {
            const { value, updated } = getValue(name, main);
            const customClass = `label-admin-client ${
              updated ? "updated-info-color" : ""
            }`;

            return (
              <div className="col-6" key={name}>
                <label className={customClass}>{label}</label>
                <input
                  className="input-admin-client input--text input-w-aux__input input--active"
                  id={name}
                  name={name}
                  value={value}
                  placeholder={placeholder}
                  readOnly={true}
                />
              </div>
            );
          })}
        </div>
      ))}
    </>
  );
};
